import { render } from "./AttrCrossGrid.vue?vue&type=template&id=3a27d7ae"
import script from "./AttrCrossGrid.vue?vue&type=script&lang=js"
export * from "./AttrCrossGrid.vue?vue&type=script&lang=js"

import "./AttrCrossGrid.vue?vue&type=style&index=0&id=3a27d7ae&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/widgets/components_core/AttrCrossGrid.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3a27d7ae"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3a27d7ae', __exports__)) {
    api.reload('3a27d7ae', __exports__)
  }
  
  module.hot.accept("./AttrCrossGrid.vue?vue&type=template&id=3a27d7ae", () => {
    api.rerender('3a27d7ae', render)
  })

}


export default __exports__